import React from "react";
import "./FormLoader.scss";
const FormLoader = () => {
  return (
    <div className="container-form-loader">
      <span className="form-loader"></span>
    </div>
  );
};

export default FormLoader;
